import axios from "axios";
import { objToParams } from "@/helpers/helpers";

export default {
    async requestUnityTypesFiles({ commit }, params = {}) {
        commit('loadingUnityTypeFiles');

        try {
            const response = await axios.get(`${process.env.VUE_APP_BACKEND_API}/unity-type/files${objToParams(params)}`);
            commit('successUnityTypeFiles', response.data);
            commit('resetSuccessUnityTypeFiles');
            return true;
        } catch(error) {
            commit('errorUnityTypeFiles', error.response.data);
            return false;
        }
    },
};
